import { FormControl, FormLabel, Stack, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldToolTip from 'components/forms/new/FieldToolTip';
import { Input } from 'components/v4';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const UsernameField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isInvalid={Boolean(errors.username) && touched.username}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>Username</FormLabel>
                <Field name="username">
                    {({ field }) => (
                        <Box className="w-full pt-[15px]">
                            <Input
                                {...field}
                                placeholder="Enter username"
                                className="!h-[30px] rounded-[5px] pl-2"
                            />
                        </Box>
                    )}
                </Field>
                {isHovered && (
                    <FieldToolTip
                        label="The username for SIP authentication (Auth ID). This is used to respond to challenges from the SIP registrar. It may be your extension or a separate ID from your SIP provider. Leave blank if not required."
                        ariaLabel="registrar-username-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default UsernameField;
